import {ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild} from '@angular/core';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {CfgARPaymentProcessorModel} from '../../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import {PaymentProcessorDeviceListModel} from '../../../configuration/models/payment-processor-device-list.model';
import {DataARPaymentModel} from '../../../../models/accountsReceivable/data-ar-payment.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {DataARClaimItemListModel} from '../../models/data-ar-claim-item-list';
import {CreatePaymentModel} from '../../models/create-payment.model';
import {DataARPaymentListModel} from '../../models/data-ar-payment-list.model';
import {CfgARAccountModel} from '../../../../models/accountsReceivable/cfg-ar-account.model';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {MatRadioChange} from '@angular/material/radio';
import {Constants} from '../../../../constants';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';

@Component({
  standalone: false,
  selector: 'app-ar-payment-refund-any-amount-confirm',
  templateUrl: './ar-payment-refund-any-amount-confirm.component.html',
  styleUrls: ['./ar-payment-refund-any-amount-confirm.component.scss']
})
export class ArPaymentRefundAnyAmountConfirmComponent implements OnInit {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;

  isLoading: boolean = true;
  refundAmount: number = 0;
  refundComment: string;
  payments: DataARPaymentListModel[] = [];
  payment: DataARPaymentListModel;
  OriginalPaymentID: string;
  paymentProcessors: CfgARPaymentProcessorModel[] = [];
  paymentDevices: PaymentProcessorDeviceListModel[] = [];
  searchPredicate: (data: any, filter: string) => boolean;
  arAccounts: CfgARAccountModel[] = [];
  arAccountID: string;
  refundMethod: string;
  activeRefundMethod: string = 'none';

  refundViaCheck: boolean = false;
  paymentAmountAfterRefund: number = 0;
  enumARProcessorID: string;
  currentWorkStationID: string;
  currentARPayment: DataARPaymentModel;
  originalPaymentProcessorID: string;
  originalPaymentDeviceID: string;

  enumPaymentTypeE: string = '00000080-1000-0000-0000-000000000003';
  enumPaymentTypeEOffline: string = '00000080-1000-0000-0000-000000000004';
  enumPaymentTypeCheck: string = '00000080-1000-0000-0000-000000000001';
  enumPaymentTypeCash: string = '00000080-1000-0000-0000-000000000002';
  enumEPayTypeCredit: string = '00000082-1000-0000-0000-000000000001';
  enumPaymentETypeCreditCard: string = '00000082-1000-0000-0000-000000000001';
  enumPaymentETypeDebitCard: string = '00000082-1000-0000-0000-000000000002';
  enumPaymentETypeCareCredit: string = '00000082-1000-0000-0000-000000000004';
  enumPaymentETypeECheck: string = '00000082-1000-0000-0000-000000000005';
  enumPaymentTransactionTypeVoidReversal: string = '00000277-1000-0000-0000-000000000002';

  enumARProcessorIDWorldPayIframe = '00000205-1000-0000-0000-000000000001';
  enumARProcessorIDSquare = '00000205-1000-0000-0000-000000000002';
  enumARProcessorIDTriPosLane3000 = '00000205-1000-0000-0000-000000000003';

  dummy: boolean = true;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<ArPaymentRefundAnyAmountConfirmComponent>,
    private readonly arService: ARService,
    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    private readonly changeDet: ChangeDetectorRef,
    private readonly globals: Globals,
    private readonly localStorageService: LocalStorageService,
  ) {
    this.searchPredicate = (searchData: DataARClaimItemListModel, filter: string) => {
      if ((!searchData.ToothName ? '' : searchData.ToothName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.ProcedureName ? '' : searchData.ProcedureName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.Code ? '' : searchData.Code).toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    };
  }

  ngOnInit(): void {

    if (this.data) {
      if (this.data.Amount) {
        this.refundAmount = this.data.Amount;
      }
    }

    // get payment accounts and payments
    this.onLoad();
  }

  saveCurrencyField(event) {

    let inputValue = '';
    if (event) { inputValue = event.target.value; }
    const newValue = Number(inputValue.replace(/[^0-9.-]+/g,''));
    this.refundAmount = newValue;

    // change detection
    this.changeDet.detectChanges();
    this.changeDet.markForCheck();
  }

  createDataARPaymentRecord() {
    const promise = new Promise((resolve, reject) => {

      const createPayment = new CreatePaymentModel();
      createPayment.datePostPayment = new Date();
      createPayment.dateReceivedPayment = new Date();
      createPayment.Description = this.refundComment ? this.refundComment : 'Refund';
      createPayment.enumARPayementCCTypeID = null; // copy from original payment
      createPayment.enumARPayementETypeID = null; // copy from original payment
      createPayment.enumARPayementTypeID = this.enumPaymentTypeE; // this needs to be based on refund method
      createPayment.enumPaymentSourceID = PAYMENT_SOURCE.Patient;
      createPayment.PatientID = this.globals.currentPatientId;
      createPayment.paymentAmount = this.refundAmount;
      createPayment.enumPaymentTransactionTypeID = this.enumPaymentTransactionTypeVoidReversal;
      createPayment.LOCID = this.globals.LOCID;

      // since this is a refund, we can default to the original payment processor id, if one exists
      if (this.payment.PaymentProcessorId) {
        createPayment.PaymentProcessorID = this.payment.PaymentProcessorId;
      }

      this.arService.createDataARPaymentRecord(createPayment)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  refundClick() {

    this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {
      if (newPayment) {

        // cfgARPayment record created
        // record new payment
        this.currentARPayment = newPayment;

        // thinking that all refunds may be done without a device
        // using the express api, if that's the case, we won't need to send a deviceid to payment component

        // if (this.enumARProcessorID === this.enumARProcessorIDTriPosLane3000) {

        //   // tripos cloud lane3000 device
        //   this.setTriPosPaymentPayload();
        //   if (this.triPosPaymentPayload) {
        //     // open payment refund confirmation dialog
        //     const dialogRef = this.dialog.open(ArTriposTerminalPaymentComponent, {
        //       panelClass: 'dialog',
        //       data: {
        //         TransactionPayload: this.triPosPaymentPayload,
        //         PaymentID: this.currentARPayment.PaymetnID,
        //         OriginalPaymentID: this.OriginalPaymentID,
        //         Amount: this.refundAmount,
        //         Action: 2,
        //         DescriptionLong: this.refundComment,
        //         DescriptionPinPad: '',
        //         // payment processor to run the refund through
        //         PaymentProcessorID: this.payment.PaymentProcessorId,
        //       }
        //     });
        //     dialogRef.afterClosed().subscribe(result => {
        //     }, err => {
        //     });
        //   }
        // }
        // else if (this.enumARProcessorID === this.enumARProcessorIDWorldPayIframe) {

        //   // worldpay hosted payments
        //   this.setWPHostedPaymentsPaymentPayload();
        //   if (this.triPosPaymentPayload) {
        //     // using tripos
        //     // open payment refund confirmation dialog
        //     const dialogRef = this.dialog.open(ArTriposTerminalPaymentComponent, {
        //       panelClass: 'dialog',
        //       data: {
        //         TransactionPayload: this.triPosPaymentPayload,
        //         PaymentID: this.currentARPayment.PaymetnID,
        //         OriginalPaymentID: this.OriginalPaymentID,
        //         Amount: this.refundAmount,
        //         Action: 2,
        //         // EnumPaymentSourceID: this.payment.enumPaymentSourceID, *do we need this?
        //         DescriptionLong: this.refundComment,
        //         DescriptionPinPad: '',
        //         PaymentProcessorID: this.payment.PaymentProcessorId,
        //       }
        //     });
        //     dialogRef.afterClosed().subscribe(result => {
        //     }, err => {
        //     });
        //   }
        // }
        // else {
        //   // check?
        // }
      }
    }, err => {
      this.createMessage('Error creating payment record', 'Error');
    });

    // close this window after opening payment window
    this.dialogRef.close();
  }

  // setWPHostedPaymentsPaymentPayload() {

  //   // perform void transaction if payment was made on current date
  //   // perform reversal transaction if payment within 45 days of current date
  //   // perform refund transaction if payment was made more than 45 days ago

  //   try {
  //     // initialize triPos transaction payload
  //     const payload = new TriPosCloudTransactionPayload();
  //     const today = new Date();
  //     const paymentDate = new Date(this.payment.PaymentTransactionDate);
  //     today.setHours(0, 0, 0, 0);
  //     paymentDate.setHours(0, 0, 0, 0);
  //     const daysAgo = this.datediff(paymentDate, today);

  //     // set shared payload values
  //     payload.PaymentID = this.payment.PaymetnID;
  //     payload.TransactionID = this.payment.PaymentTransactionId;
  //     payload.PaymentProcessorID = this.payment.PaymentProcessorId;

  //     if (this.refundAmount < this.payment.PaymentAmount) {
  //       // only a portion of payment is being returned, so we will always execute a refund
  //       if (daysAgo <= 45) {
  //         payload.RefundMethod = 'refund';
  //       }
  //       else {
  //         // since payment is past 45 days, a check must be issued
  //       }
  //     }
  //     else
  //     {
  //       if (paymentDate === today) {
  //         payload.RefundMethod = 'void';
  //       }
  //       else if (paymentDate < today) {

  //         if (daysAgo <= 45) {
  //           // payment was not made today, but is within 45 days
  //           payload.RefundMethod = 'reversal';
  //         }
  //         else {
  //           // payment was made more than 45 days ago
  //           payload.RefundMethod = 'refund';
  //         }
  //       }
  //     }

  //     // set payload for use in refund click event
  //     this.triPosPaymentPayload = payload;
  //   }
  //   catch (err) {
  //     this.createMessage('Error getting refund method', 'Error');
  //   }
  // }

  // setTriPosPaymentPayload() {

  //   // perform void transaction if payment was made on current date
  //   // perform reversal transaction if payment within 45 days of current date
  //   // perform refund transaction if payment was made more than 45 days ago

  //   try {
  //     // initialize triPos transaction payload
  //     const payload = new TriPosCloudTransactionPayload();
  //     const today = new Date();
  //     const paymentDate = new Date(this.payment.PaymentTransactionDate);
  //     today.setHours(0, 0, 0, 0);
  //     paymentDate.setHours(0, 0, 0, 0);
  //     const daysAgo = this.datediff(paymentDate, today);

  //     // set shared payload values
  //     payload.PaymentID = this.payment.PaymetnID;
  //     payload.TransactionID = this.payment.PaymentTransactionId;
  //     payload.PaymentProcessorID = this.payment.PaymentProcessorId;

  //     if (this.refundAmount < this.payment.PaymentAmount) {
  //       // only a portion of payment is being returned, so we will always execute a refund
  //       if (daysAgo <= 45) {
  //         payload.RefundMethod = 'refund';
  //       }
  //       else {
  //         // since payment is past 45 days, a check must be issued
  //         payload.RefundMethod = 'check';
  //       }
  //     }
  //     else
  //     {
  //       if (paymentDate === today) {
  //         payload.RefundMethod = 'void';
  //       }
  //       else if (paymentDate < today) {

  //         if (daysAgo <= 45) {
  //           // payment was not made today, but is within 45 days
  //           payload.RefundMethod = 'reversal';
  //         }
  //         else {
  //           // payment was made more than 45 days ago
  //           payload.RefundMethod = 'refund';
  //         }
  //       }
  //     }

  //     // set payload for use in refund click event
  //     this.triPosPaymentPayload = payload;
  //   }
  //   catch (err) {
  //     this.createMessage('Error getting refund method', 'Error');
  //   }
  // }

  cancelClick() {
    this.dialogRef.close();
  }

  getPaymentProcessorDevicesByWorkstation(WorkstationID: string, LOCID: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getPaymentProcessorDevicesByWorkstation(WorkstationID, LOCID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllDoctorARLocations() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllDoctorARLocations()
        .subscribe(resolve, reject);
    });
    return promise;
  }

  async onLoad() {
    this.currentWorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
    const locid = localStorage.getItem('LOCID');

    const promises: any[] = [
      this.getPatientPayments(this.globals.currentPatientId),
      this.getPaymentProcessors(),
      this.getPaymentProcessorDevicesByWorkstation(this.currentWorkStationID, locid),
      this.getAllDoctorARLocations(),
    ];

    try {
      // get payment record
      const results: any[] = await Promise.all(promises);
      this.payments = results[0];
      this.paymentProcessors = results[1];
      this.paymentDevices = results[2];
      this.arAccounts = results[3];
      this.isLoading = false;
    }
    catch (err) {
      this.createMessage('Error retrieving payment records', 'Error');
    }
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.payment = event.model;
    this.OriginalPaymentID = this.payment.PaymetnID;

    // set araccountid
    this.arAccountID = this.payment.ARAccountID;

    // set processor
    this.activeRefundMethod = 'none';
    if (this.payment.PaymentProcessorId && this.payment.PaymentProcessorId !== Constants.emptyGuid) {
      this.originalPaymentProcessorID = this.payment.PaymentProcessorId;
      this.paymentProcessors.forEach(a => {
        if (this.originalPaymentProcessorID === a.PaymentProcessorId) {
          this.refundMethod = a.Name;
          this.enumARProcessorID = a.enumARProcessorID;
        }
      });
      this.activeRefundMethod = 'cc';
    }
    else {
      this.refundMethod = 'Cash / Check';
      this.activeRefundMethod = 'check';
    }
  }

  changeRefundMethod(eventChange: MatRadioChange) {
    //
    // if (eventChange.value === 'cc') {
    //   // change to credit card
    //   this.activeRefundMethod = 'cc'
    // }
    // else if (eventChange.value === 'check') {
    //   // change to check
    // }
    // else {
    //   // change to nothing
    // }
  }

  getPatientPayments(PatientID: string) {
    return this.arService.getPatientPayments(PatientID).toPromise();
  }

  datediff(first, second) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }

  getPaymentProcessors() {
    return this.arService.getPaymentProcessors().toPromise();
  }
  // getPayment(PaymentID: string) {
  //   return this.arService.getPayment(PaymentID).toPromise();
  // }

  // getPaymentRefundDistributions(PaymentID: string) {
  //   return this.arService.getPaymentRefundDistributions(PaymentID).toPromise();
  // }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  // returnPaymentType() {
  //   if (this.payment.enumARPayementTypeID === this.enumPaymentTypeCheck) {
  //     return this.payment.PaymentType;
  //   }
  //   else if (this.payment.enumARPayementTypeID === this.enumPaymentTypeCash) {
  //     return this.payment.PaymentType;
  //   }
  //   else {
  //     let payType = this.payment.PaymentType;
  //     if (this.payment.PaymentElectronicType) {
  //       payType += ' / ' + this.payment.PaymentElectronicType;
  //     }
  //     if (this.payment.PaymentCCType) {
  //       payType += ' / ' + this.payment.PaymentCCType;
  //     }
  //     return payType;
  //   }
  // }

  refundButtonDisabled() {
    if (this.refundAmount > 0 && this.arAccountID) {
      return false;
    }
    else {
      return true;
    }
  }

}
